import { animate } from 'animejs';

const slide = (slider, prevIndex, revealedIndex) => {
  animate(slider.current.querySelector('.inner'), {
    ease: 'outQuad',
    duration: 200,
    translateY: [prevIndex * (-1 * 120), -1 * 120 * revealedIndex - revealedIndex * 2],
  });
};

export { slide };
